import BundleProductCard from './BundleProductCard';

export default BundleProductCard;
